<template>
  <div class="bluefire-wap-wrap">
    <wap-header header-text="学生管理" :header-visible="true" :back-visible="true" /><!--参数都可以不传-->
    <scroll-refresh>
      <div class="searchHead">
        <div class="searchInput">
          <el-button :class="screenBtnStyle ? 'active' : ''" type="primary" @click="showFilter">筛选</el-button>
          <el-input
            placeholder="姓名/昵称/手机号/微信/QQ/客户编码"
            @change="search()"
            v-model="searchData.uname">
          </el-input>
        </div>
        <div :class="btnLoadLock ? 'buttonInput active' : 'buttonInput'">
          <el-radio-group v-model="toptab" @change="tabChange">
            <el-radio-button label="学生管理"></el-radio-button>
            <el-radio-button label="公海资源">
              <span class="special">公海资源
                <!--<i>{{ waterNewCounts }}</i>-->
              </span>
            </el-radio-button>
          </el-radio-group>
        </div>
        <div class="textInput">
          <div class="moreuser-select" v-if="$hasPermission([1, 22, 33, 36, 39, 42, 51, 101, 121, 122, 142, 148])">
            <el-select v-model="searchData.crm_sayer" @change="search" placeholder="全部员工" clearable>
              <el-option
                v-for="item in teachers"
                :key="item.key"
                :label="item.name"
                :value="item.key"/>
            </el-select>
          </div>
          <el-button v-show="toptab === '学生管理'" type="text" @click="fetchList('')" >全部</el-button>
          <el-button v-show="toptab === '学生管理'" type="text" @click="fetchList('create_today')" >今日新增资源</el-button>
          <el-button v-show="toptab === '学生管理'" type="text" @click="fetchList('visit-1')">等待处理待回访资源</el-button>
          <el-button v-show="toptab === '公海资源'" type="text" @click="gonghai">全部公海资源</el-button>

        </div>
      </div>
      <div class="tools-wrap">
        <data-list :url="url"
                   :search-data="searchData"
                   :refresh.sync="refresh">
          <template slot-scope="{ item, header, refresh }">
            <div class="student">
              <student-card :item="item" :header="header" :refresh.sync="refresh"></student-card>
              <div class="plantask-btn-content">
                <router-link :to="{ name: 'h5User', params: { crmid: item.id } }">
                  <el-button state-key="fib.jiemo.net/h5/userList/studentCard-查看" :state-status="true">查看</el-button>
                </router-link>
                <router-link :to="{ name: 'h5EditUser', params: { crmid: item.id } }">
                  <el-button state-key="fib.jiemo.net/h5/userList/studentCard-编辑" :state-status="true">编辑</el-button>
                </router-link>
                <el-button @click="showReturnVisit(item.id)" state-key="fib.jiemo.net/h5/userList/studentCard-快速回访" :state-status="true">快速回访</el-button>
                <el-button v-if="showRoundAddCheck(1)" @click="showAddStudent(item.id)" >转介绍添加</el-button>
                <el-button v-if="showRoundAddCheck(2)" @click="showFinancial({ type: 2, crm_id: item.id })" state-key="fib.jiemo.net/h5/userList/studentCard-财务报账" :state-status="true">财务报账</el-button>
              </div>
            </div>
          </template>
        </data-list>
      </div>
    </scroll-refresh>
    <el-button
      class="edit-fixed"
      type="primary"
      size="mini"
      @click="showAddStudent(0)"
      state-key="fib.jiemo.net/h5/userList/fixed-添加资源"
      :state-status="true"
    >添加<br/>资源</el-button>
    <popupadd-student :show-lock.sync="showAddStudentLock" :options="defaultAttr">
      <el-button slot="close-button" @click="closePopupAddStudent" class="btn-close-popup"><font>×</font></el-button>
    </popupadd-student>
    <popup-student-form-filter :show-lock.sync="showFilterLock" :search-data.sync="searchData" :options="options" @clearSearchData="clearSearchData">
      <el-button slot="close-button" @click="closePopupFilter" class="btn-close-popup-fullpage"><font>×</font></el-button>
    </popup-student-form-filter>
    <popup-return-visit :show-lock.sync="showReturnVisitLock" :crm_id="crm_id" :operate-visit="operateVisit">
      <el-button slot="close-button" @click="closeReturnVisit" class="btn-close-popup"><font>×</font></el-button>
    </popup-return-visit>
    <popup-financial :show-lock.sync="financialLock" :financial-form="financialForm">
      <el-button slot="close-button" @click="closeFinancial" class="btn-close-popup"><font>×</font></el-button>
    </popup-financial>
  </div>
</template>
<script>

import header from './compoments/header';
import scrollRefresh from './compoments/scrollRefresh';
import DataList from './compoments/dataList';
import StudentCard from './compoments/studentCard';
import popupaddStudent from './compoments/popupaddStudent';
import popupStudentFormFilter from './compoments/popupStudentFormFilter';
import popupReturnVisit from './compoments/popupReturnVisit';
import popupFinancial from './compoments/popupFinancial';

let financial = {
  crm_id: 0,
};

export default {
  data() {
    return {
      btnLoadLock: false, // 加载时添加按钮锁
      url: '/index/student/pagetable',
      screenBtnStyle: false, // 筛选是否有条件
      toptab: '学生管理',
      showAddStudentLock: false,
      showFilterLock: false,
      showReturnVisitLock: false,
      financialLock: false,
      refresh: false,
      waterNewCounts: 0,
      searchContent1: '',
      crm_id: 0,
      searchData: {
        uname: '',
        activeCountries: '',
        intentionCountries: '',
        signingStatus: '',
        InternationalWaters: 0,
        creationDate: [],
        lastvisittime2: [],
        customerClassification: '',
        channel: {
          custom_from: '',
          custom_from_sub: '',
          custom_from_thrid: '',
          custom_from_fourth: '',
          custom_from_fifth: ''
        },
        searchType: '',
        crm_sayer: ''
      },
      operateVisit: 'fib',
      financialForm: financial,
      options: [
      ],
      teachers: [
      ],
      defaultAttr: {
        addFormType: 0
      }
    };
  },
  computed: {
  },
  methods: {
    // 打开财务报账或支付邀约
    showFinancial(data) {
      this.financialForm = Object.assign({}, financial, data);
      this.financialLock = true;
    },
    // 关闭财务报账或支付邀约
    closeFinancial() {
      this.financialLock = false;
    },
    visit() {
      this.showVisitLock = true;
    },
    // 打开快速回访弹窗
    showReturnVisit: function(id) {
      this.showReturnVisitLock = true;
      this.crm_id = id;
    },
    // 关闭回访弹窗
    closeReturnVisit: function() {
      this.showReturnVisitLock = false;
    },
    // tab切换
    tabChange: function(val) {
      this.screenBtnStyle = false;
      if (val === '学生管理') {
        this.studentManage();
      } else {
        this.gonghai();
      }
    },
    search() {
      this.refresh = true;
    },
    fetchList(typeStr) {
      this.searchData.searchType = typeStr;
      this.refresh = true;
    },
    studentManage() {
      this.url = '/index/student/pagetable';
      this.searchData.creationDate = [];
      this.searchData.lastvisittime2 = [];
      this.searchData.searchType = '';
      this.searchData.InternationalWaters = 0;
      this.refresh = true;
    },
    gonghai() {
      this.url = '/index/student/pagetable';
      this.searchData.creationDate = [];
      this.searchData.lastvisittime2 = [];
      this.searchData.searchType = '';
      this.searchData.InternationalWaters = 1;
      this.refresh = true;
    },
    clearSearchData() {
      Object.keys(this.searchData).forEach((key) => {
        if (typeof this.searchData[key] !== 'object') {
          this.searchData[key] = '';
        }
      });
      this.searchData.channel.custom_from = '';
      if (this.toptab === '学生管理') {
        this.studentManage();
      } else {
        this.gonghai();
      }
      this.closePopupFilter();
    },
    getDate() {
      let yy = new Date().getFullYear();
      let mm = new Date().getMonth() + 1;
      let dd = new Date().getDate();
      return `${yy}-${mm}-${dd}`;
    },
    showAddStudent(val) {
      this.defaultAttr.addFormType = val;
      this.showAddStudentLock = true;
    },
    closePopupAddStudent() {
      this.showAddStudentLock = false;
      this.refresh = true;
    },
    showFilter() {
      this.showFilterLock = true;
    },
    closePopupFilter() {
      this.showFilterLock = false;
      this.refresh = true;
    },
    // 刷新计数
    resetWaterNum() {
      this.$http._get({
        url: '/index/student/getnewcount',
      }).then(({ data }) => {
        this.waterNewCounts = data;
      });
    },
    showRoundAddCheck(val) {
      if (val === 1) {
        if (this.$hasPermission([20, 54, 43])) {
          return true;
        }
        return false;
      }
      if (val === 2) {
        if (this.$hasPermission([20, 54])) {
          return false;
        }
        return true;
      }
    },
    showTeachers() {
      this.$http
        ._get({
          url: '/index/plantask/plantaskInterface'
        })
        .then(({ data }) => {
          this.teachers = data.teachers;
        });
    }
  },
  watch: {
    showAddStudentLock() {
      if (!this.showAddStudentLock) {
        this.closePopupAddStudent();
      }
    },
    showFilterLock() {
      if (!this.showFilterLock) {
        this.closePopupFilter();
      }
    },
    refresh() {
      if (this.refresh) {
        this.btnLoadLock = true;
      } else {
        this.btnLoadLock = false;
      }
      if (this.searchData.uname !== ''
          || this.searchData.activeCountries !== ''
          || this.searchData.intentionCountries !== ''
          || this.searchData.signingStatus !== ''
          // || this.searchData.InternationalWaters
          || this.searchData.creationDate.length > 0
          || this.searchData.lastvisittime2.length > 0
          || this.searchData.customerClassification !== ''
          || this.searchData.channel.custom_from !== ''
          || this.searchData.channel.custom_from_sub !== ''
          || this.searchData.channel.custom_from_thrid !== ''
          || this.searchData.channel.custom_from_fourth !== ''
          || this.searchData.channel.custom_from_fifth !== '') {
        this.screenBtnStyle = true;
      } else {
        this.screenBtnStyle = false;
      }
    },
    components: {
      'wap-header': header,
      'data-list': DataList,
      'student-card': StudentCard,
      popupaddStudent,
      // popupFilter
    }
  },
  mounted() {
    this.refresh = true;
    // this.fetchData();
    this.showTeachers();
  },
  components: {
    'wap-header': header,
    'data-list': DataList,
    'student-card': StudentCard,
    popupaddStudent,
    popupStudentFormFilter,
    popupReturnVisit,
    popupFinancial,
    scrollRefresh
  }
};
</script>
<style>
  .bluefire-wap-wrap .buttonInput.active{
    pointer-events: none;
  }
  .bluefire-wap-wrap .buttonInput .el-radio-group .el-radio-button .el-radio-button__inner{
    width: 46vw;
    color: #0496ff;
    border-color: #0496ff;
  }
  .bluefire-wap-wrap .buttonInput .el-radio-group .el-radio-button.is-active .el-radio-button__inner{
    color: #fff;
    background: #0496ff;
  }
  .bluefire-wap-wrap .buttonInput .el-radio-group .el-radio-button span.special{
    position: relative;
  }
  .bluefire-wap-wrap .buttonInput .el-radio-group .el-radio-button span.special i{
    position: absolute;
    left: 100%;
    bottom: 68%;
    padding: 0 0.6vw;
    height: 3.2vw;
    line-height: 3.2vw;
    background: #ff3a3a;
    color: #fff;
    font-size: 2.66vw;
    text-align: center;
    border-radius: 1.6vw;
  }
  .bluefire-wap-wrap .searchInput .el-input .el-input__inner{
    height: 9vw;
    border-radius: 4.5vw;
    border: none;
    font-size: 3.73vw;
    background: #f3f3f3 url("../../assets/wap/icon-search.png") no-repeat 4vw center;
    background-size: auto 4vw;
    padding-left: 11vw;
  }
  .tools-wrap .tab-content1 .form-tools .el-select .el-input__inner{
    border: none;
    color: #0496ff;
  }
  .tools-wrap .tab-content1 .form-tools .el-select .el-input .el-select__caret{
    color: #0496ff;
  }
  .form-student-tools .first-level-tab{
    display: flex;
    justify-content: flex-start;
    background: #fff;
    padding: 0 8vw;
    line-height: 12.2vw;
    white-space: nowrap;
    overflow-x: auto;
    box-shadow: 0 0.5vw 0.5vw rgba(224,224,224,.25);
  }
  .form-student-tools .first-level-tab .el-radio-button .el-radio-button__inner{
    background: none;
    border: none;
    border-radius: 0;
    padding: 0;
    line-height: 12vw;
    border-bottom: 0.8vw solid transparent;
    box-shadow: none;
    margin-right: 8vw;
  }
  .form-student-tools .first-level-tab .el-radio-button.is-active .el-radio-button__inner{
    color: #0496ff;
    line-height: 12vw;
    border-bottom: 0.8vw solid #0496ff;
    box-shadow: none;
  }
  .form-student-tools .second-level-tab{
    padding: 4vw;
    display: flex;
    justify-content: space-around;
  }
  .form-student-tools .second-level-tab .el-radio-button .el-radio-button__inner{
    background: none;
    border: none;
    height: 6.4vw;
    line-height: 6.4vw;
    border-radius: 3.2vw;
    padding: 0 2.6vw;
    color: #666;
    font-size: 3.73vw;
    box-shadow: none;
  }
  .form-student-tools .second-level-tab .el-radio-button.is-active .el-radio-button__inner{
    background: #E0F2FF;
    color: #0496ff;
  }
  .textInput .moreuser-select{
    display: inline-block;
    vertical-align: middle;
    padding-right: 3vw;
    margin-right: 3vw;
    border-right: 1px solid #dedede;
  }
  .textInput .moreuser-select .el-select{
    width: 18vw;
  }
  .textInput .moreuser-select .el-select .el-input__inner{
    height: auto;
    line-height: 6.4vw;
    background: none;
    padding: 0;
    font-size: 3.73vw;
    font-weight: bold;
    border-radius: 0;
    border: none;
    color: #0496ff;
  }
  .textInput .moreuser-select .el-select .el-input__inner::placeholder{
    color: #0496ff;
  }
  .textInput .moreuser-select .el-select .el-input .el-select__caret{
    font-family: "微软雅黑", Microsoft Yahei !important;
    font-size: 0;
    width: 0;
    height: 0;
    overflow: hidden;
    border-top: 1vw solid #0496ff;
    border-left: 0.8vw solid transparent;
    border-right: 0.8vw solid transparent;
    transform: translateY(-50%);
    top: 50%;
    position: absolute;
  }
</style>
<style scoped>
  /*顶部菜单*/
  .menu-dev {
    width: 100%;
    text-align: center;
    background: #fff;
  }
  .menu-dev .el-radio-group {
    width: 100%;
  }
  .menu-dev .el-radio-group .el-radio-button__inner {
    width: 46vw;
    display: inline-block;
  }

  .tab-content1 .form-tools{
    display: flex;
    justify-content: space-between;
    background: #fff;
    padding: 1vw 4vw;
    margin-bottom: 3vw;
  }

  /*待办任务列表*/
  .task-content {
    text-align: center;
  }
  .item {
    width: 100%;
    margin: 0vw;
    padding: 0 0 4vw;
    text-align: left;
    background: #FFF;
    border-radius: 11px;
    display: block;
  }
  .item p {
    padding: 2vw 0;
  }
  .item .btn-area{
    display: flex;
    justify-content: flex-start;
    border-top: 0.5px solid #CFCFCF;
    padding-top: 4vw;
    padding-bottom: 1vw;
  }
  .item .btn-area .el-button{
    padding: 0 2vw;
    height: 8vw;
    line-height: 8vw;
    border-radius: 4vw;
  }
  .item .tk-type {
    font-style: normal;
    font-weight: normal;
    font-size: 3.46vw;
    line-height: 4.26vw;
    align-items: center;
    text-align: center;
    display: inline-block;
    border: 0.5px solid;
    box-sizing: border-box;
    border-radius: 0.5vw;
    padding: 0.5vw 1vw;
  }
  .item .tk-type-1 {
    color: #24BC85;
    border-color: #24BC85;
  }
  .item .tk-type-2 {
    color: #0496FF;
    border-color: #0496FF;
  }
  .item .tk-type-3 {
    color: #6631FF;
    border-color: #6631FF;
  }
  .item .tk-type-4 {
    color: #FF124B;
    border-color: #FF124B;
  }
  .item .tk-date {
    font-style: normal;
    font-weight: 600;
    font-size: 4vw;
    line-height: 3.73vw;
    padding-left: 3vw;
    display: inline-block;
  }

  .item .tk-status-right {
    float: right;
    font-style: normal;
    font-weight: normal;
    font-size: 3.73vw;
    line-height: 5.3vw;
    display: flex;
    align-items: center;
    text-align: center;

    color: #FF9736;
  }

  .item .tk-memo-title {
    font-style: normal;
    font-weight: normal;
    font-size: 4vw;
    line-height: 5.4vw;
    width: 12vw;
    color: #A8AFC9;
    display: inline-block;
  }
  .item .tk-memo-content {
    display: inline-block;
    box-sizing: border-box;
    width: 80vw;
    height: 16vw;
    padding: 1.2vw 4vw;
    background: #F1F5FC;
    border-radius: 1.6vw;
    font-style: normal;
    font-weight: normal;
    font-size: 4vw;
    line-height: 5.4vw;
    color: #8F99BF;
  }
  .item .tk-title {
    display: block;
    margin: 1vw 0;
    font-style: normal;
    font-weight: normal;
    font-size: 4vw;
    line-height: 5.4vw;
    color: #A8AFC9;
  }
  .item .el-button {
    background: #FFFFFF;
    border: 0.5px solid #BABABA;
    box-sizing: border-box;
    border-radius: 5vw;
    font-style: normal;
    font-weight: normal;
    font-size: 3.73vw;
    line-height: 5.3vw;
    color: #333333;
  }

  /* 添加按钮 */
  .edit-fixed {
    position: fixed;
    right: 4vw;
    bottom: 24vw;
    width: 14vw;
    height: 14vw;
    padding: 0;
    border-radius: 50%;
    text-align: center;
    z-index: 19;
    line-height: 4vw;
    font-size: 3vw;
  }
  .plantask-btn-content{
    border-top: 0.5px solid #cfcfcf;
    margin-top: 3.3vw;
    padding: 3vw 0;
    text-align: right;
  }
  .plantask-btn-content .el-button{
    font-size: 3.73vw;
    padding: 0;
    height: 8vw;
    line-height: 8vw;
    width: 20.2vw;
    margin-left: 2vw;
    border-radius: 4vw;
    border:0.5px solid #bababa;
    background: none;
    color: #333;
  }
  .searchHead{
    background: #fff;
    margin-bottom: 3vw;
  }
  .searchInput{
    padding: 0 4vw 3.73vw;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .searchInput .el-button{
    width: 23%;
    height: 36px;
    line-height: 36px;
    background: url("../../assets/wap/icon-filter.png") no-repeat 84% center;
    background-size: 3.6vw auto;
    color: #333;
    border: 1px solid #ececec;
    margin-right: 0;
    padding:0 3.5vw 0 0;
    border-radius: 18px;
    font-size: 4vw;
  }
  .searchInput .el-button.active{
    background: url("../../assets/wap/icon-filteron.png") no-repeat 84% center;
    background-size: 3.6vw auto;
    color: #0496ff;
  }
  .searchInput .el-input{
    width: 74%;
  }
  .buttonInput{
    display: flex;
    justify-content: space-between;
    width: 92vw;
    margin: auto
  }
  .buttonInput .el-button{
    width: 50%;
  }
  .textInput{
    padding: 4vw;
    position: relative;
    white-space: nowrap;
    overflow-x: auto;
    overflow-y: hidden;
  }
  .textInput::after{
    clear: both;
    display: block;
    content: "";
  }
  .textInput .el-button{
    padding: 0;
    color: #333;
    margin-left: 0;
    margin-right: 3.8vw;
    font-size: 3.73vw;
    line-height: 7.46vw;
    vertical-align: middle;
    background: none;
    border: none
  }
  .textInput .el-button:active, .textInput .el-button:hover{
    color: #0496ff;
  }

</style>
